module.exports = __webpack_public_path__ + "static/media/EHS-ECM-and-Accountability-Policy-protected.2a76c4ae.pdf";